import React from "react";
import { SnackbarProvider } from "notistack";
import WaMenuList from "./WaMenuList";

export default function WaMenusWithSnacks() {
    return (
        <SnackbarProvider maxSnack={3} autoHideDuration={2500} preventDuplicate>
            <WaMenuList />
        </SnackbarProvider>
    );
}